// Components
import { TooltipHost as FluentTooltipHost, DirectionalHint, useTheme } from "@fluentui/react";
// Styles
import { getCalloutStyles, getTooltipStyleFunction } from "./Tooltip.styles";
// Utilities
import * as React from "react";
/**
 * TooltipHost control that customizes the fluent control to our own purposes
 */ export const TooltipHost = (props)=>{
    const { tooltipProps, calloutProps, directionalHint, children } = props;
    const modifiedTooltipProps = {
        ...tooltipProps,
        styles: getTooltipStyleFunction(tooltipProps?.styles)
    };
    const modifiedCalloutProps = {
        ...calloutProps,
        styles: getCalloutStyles(useTheme(), calloutProps?.styles)
    };
    return /*#__PURE__*/ React.createElement(FluentTooltipHost, {
        className: "unoTooltip",
        tooltipProps: modifiedTooltipProps,
        calloutProps: modifiedCalloutProps,
        directionalHint: directionalHint ?? DirectionalHint.bottomCenter,
        theme: useTheme(),
        ...props
    }, children);
};
